const page       = require('../../../../../components/page/page')
const clientPaymentsDt = require('./clientPayments-dt')

import clientPaymentsPage       from "./clientPayments-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ 
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", clientPaymentsPage)

   clientPaymentsDt.start({"dest":"clientPayments", "elem":"dt", "act":"select", "entity":"clientPayments"})

}/*init*/

/****************ELEMENTS*****************/
export function start(detail){ 
   if(!HTMLwasSelected) {HTMLselect(detail)}
	obj[detail.act].start(detail)
}

const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},
}/**/
